export default "__VITE_ASSET__BvQ$0BS$__"